export default __webpack_public_path__ + "static/media/3.17b1093b.jpg";